import api from '@/services/api'

export default {
  getPendencies(params) {
    let queryString = this.createQueryString(params);
    return api.get(`/pendencies${queryString}`);
  },

  exportPendencies(params) {
    let queryString = this.createQueryString(params) + '&export=true';

    return api({
      url: `/pendencies${queryString}`,
      method: 'GET',
      responseType: 'blob',
    })
  },

  createQueryString(params) {
    let queryString = `?page=${params.page || 1}`;

    if (params.customer) {
      queryString += `&customer=${params.customer}`;
    }

    if (params.period) {
      if (params.startDate) {
        const startDate = new Date(params.startDate);
        queryString += `&startDate=${startDate.getFullYear()}-${startDate.getMonth() + 1}-${startDate.getDate()}`;
      }

      if (params.endDate) {
        const endDate = new Date(params.endDate);
        queryString += `&endDate=${endDate.getFullYear()}-${endDate.getMonth() + 1}-${endDate.getDate()}`;
      }
    }

    return queryString;
  },
}